<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-key`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M30 3c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15a14.936 14.936 0 01-9.235-3.179l-4.425 5.273 3.127 2.624a1 1 0 01.123 1.408l-1.286 1.533a1 1 0 01-1.408.123l-3.127-2.624-5.062 6.032a1 1 0 01-1.409.123l-1.532-1.285a1 1 0 01-.123-1.409l12.213-14.555c.034-.04.07-.077.109-.111A14.927 14.927 0 0115 18c0-8.284 6.716-15 15-15zm0 4c-6.075 0-11 4.925-11 11s4.925 11 11 11 11-4.925 11-11S36.075 7 30 7z"/></svg>
</template>
<script>

export default {
  name: 'IconKey',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
